import Box from "@mui/material/Box";

import { setQuoteCalculationStatusOverride } from "../../api/quote/setQuoteCalculationStatusOverride";
import APToggleChip from "./APToggleChip";

const APInvalidCalculationToggle = ({
  quoteId,
  dossierId,
  status,
}: {
  quoteId: string;
  dossierId: string;
  status: "invalid" | "valid-override";
}) => {
  const { mutate: setQuoteCalculationStatusOverrideMutation } =
    setQuoteCalculationStatusOverride();

  const onToggle = (status: "invalid" | "valid-override") => {
    setQuoteCalculationStatusOverrideMutation({
      quoteId,
      calculationStatus: status,
      dossierId,
    });
  };

  return (
    <Box sx={{ display: "flex" }}>
      {status === "invalid" && (
        <APToggleChip
          icon="warning"
          text="Invalid Calculations"
          toggleText="Override to Valid"
          color="error"
          onToggle={() => onToggle("valid-override")}
        />
      )}
      {status === "valid-override" && (
        <APToggleChip
          icon="check-circle"
          text="Valid Calculations - Overriden"
          toggleText="Override to Invalid"
          color="success"
          onToggle={() => onToggle("invalid")}
        />
      )}
    </Box>
  );
};

export default APInvalidCalculationToggle;
